import { Droppable, DroppableProps } from '@salecycle/experimental/DragAndDrop/Droppable';
import Icon from './assets/WorkflowIcon.svg?react';
import { EdgeLabelRenderer } from 'reactflow';
import styled from 'styled-components';

export interface ConnectorButtonProps {
  labelX: number;
  labelY: number;
  show: boolean;
  droppableProps: DroppableProps;
}

const StyledButton = styled.div`
  /* 
    Each animation should run for 600ms, with a break of 1200ms. This means our total
    running time is 2400ms. 

    We break the times down into percentages by doing:
      - 600 / 2400 = 25% (fade in)
      - 600 / 2400 = 25% (fade out)
      - 1200 / 2400 = 50% (delay)
  */
  @keyframes flash {
    0% {
      outline: 4px solid transparent;
    }
    25% {
      outline: 4px solid ${({ theme }) => theme.designToken.primary300};
    }
    75% {
      outline: 4px solid ${({ theme }) => theme.designToken.primary300};
    }
    100% {
      outline: 4px solid transparent;
    }
  }

  border-radius: 50%;
  height: 27px;
  width: 27px;
  outline: 4px solid transparent;
  animation: 2400ms ease-out 1ms infinite flash;
  background-color: ${({ theme }) => theme.designToken.primary50};
  color: ${({ theme }) => theme.designToken.primary500};
  z-index: 1000;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ConnectorButton = ({ labelX, labelY, show, droppableProps }: ConnectorButtonProps) => {
  if (!show) {
    return null;
  }

  return (
    <EdgeLabelRenderer>
      <div
        style={{
          position: 'absolute',
          transform: `translate(-50%, -65%) translate(${labelX}px,${labelY}px)`,
          pointerEvents: 'all',
        }}
      >
        <Droppable {...droppableProps}>
          <StyledButton>
            <Icon />
          </StyledButton>
        </Droppable>
      </div>
    </EdgeLabelRenderer>
  );
};
